<template>
  <div class="deposit-page">
    <!-- ===== 顶部标题 ===== -->
    <div class="deposit-header">
      <h1 class="deposit-title">{{ $t("depositPage.title") }}</h1>
      <p class="deposit-desc">{{ $t("depositPage.desc") }}</p>
    </div>


    <!-- ===== 主体 ===== -->
    <div class="deposit-body">
      <div class="deposit-container">
        <!-- 余额 -->
        <div class="balance-card">
          <div>
            <span class="balance-label">{{ $t("depositPage.balance") }}</span>
            <span class="balance-amount">${{ wallet.balance }}</span>
          </div>
          <!-- <span class="balance-sub">≈ 0.42 BTC</span> -->
        </div>

        <!-- 充值方式切换 -->
        <div class="method-tabs">
          <button
            class="method-tab"
            :class="{ active: depositMethod === 'crypto' }"
            @click="depositMethod = 'crypto'"
          >
            {{ $t("depositPage.methodCrypto") }}
          </button>
          <!-- <button
            class="method-tab"
            :class="{ active: depositMethod === 'online' }"
            @click="depositMethod = 'online'"
          >
            {{ $t("depositPage.methodOnline") }}
          </button> -->
        </div>

        <!-- ===== 加密货币 ===== -->
        <template v-if="depositMethod === 'crypto'">
          <!-- 币种 -->
          <div class="form-group">
            <label class="form-label">{{ $t("depositPage.coin") }}</label>

            <div class="coin-grid">
              <div
                class="coin-option"
                v-for="coin in coins"
                :key="coin.value"
                :class="{ active: selectedCoin === coin.value }"
                @click="selectedCoin = coin.value"
              >
                <span class="coin-icon">
                  <img
                    :src="getCoinIcon(coin.text)"
                    alt=""
                    class="coin-img"
                  />
                </span>
                <span class="coin-name">{{ coin.text }}</span>
              </div>
            </div>
          </div>

          <!-- 协议 -->
          <div class="form-group" v-if="selectedCoin">
            <label class="form-label">{{ $t("depositPage.protocol") }}</label>

            <div class="protocol-grid">
              <div
                class="protocol-option"
                v-for="protocol in filteredProtocols"
                :key="protocol.id"
                :class="{ active: selectedProtocol === protocol.id }"
                @click="selectedProtocol = protocol.id"
              >
                <span class="protocol-name">{{ protocol.network }}</span>
                <span class="protocol-sub">{{ protocol.name }}</span>
              </div>
            </div>
          </div>

          <!-- 二维码 + 地址 -->
          <div class="payment-info" v-if="selectedProtocol">
            <div class="qr-row">
              <div class="qr-wrapper">
                <img
                  v-if="currentQrCode"
                  :src="currentQrCode"
                  :alt="$t('depositPage.qrAlt')"
                  class="qr-img"
                />
                <div v-else class="qr-placeholder">{{ $t("depositPage.qrPlaceholder") }}</div>
              </div>

              <div class="address-area">
                <div class="address-box">
                  <code class="address-text">{{ currentAddress }}</code>
                  <button class="btn-copy" @click="copyAddress">
                    {{ copied ? $t("depositPage.copied") : $t("depositPage.copy") }}
                  </button>
                </div>
                <div class="address-warning" v-html="$t('depositPage.addressWarning', { coin: selectedCoinLabel, protocol: selectedProtocolLabel })"></div>
                <!-- <div class="fee-info" v-if="transferFee">
                  {{ $t("depositPage.feeInfo", { fee: transferFee }) }}
                </div> -->
              </div>
            </div>

            <!-- <div class="action-row">
              <input
                type="number"
                class="amount-input"
                v-model="depositAmount"
                :placeholder="$t('depositPage.amountPlaceholder')"
              />
              <button class="btn-deposit" @click="handleDeposit">
                {{ $t("depositPage.transferBtn") }}
              </button>
            </div> -->
          </div>

          <div v-else class="empty-state">{{ $t("depositPage.emptyState") }}</div>

        </template>

        <!-- ===== 线上充值 ===== -->
        <template v-if="depositMethod === 'online'">
          <div class="online-grid">
            <div
              class="online-card"
              v-for="item in onlineMethods"
              :key="item.name"
            >
              <span class="online-icon">{{ item.icon }}</span>
              <div>
                <h4>{{ item.name }}</h4>
                <p>{{ item.desc }}</p>
              </div>
              <button class="btn-online">{{ item.btn }}</button>
            </div>
          </div>
        </template>

        <!-- ========================================================== -->
        <!-- ===== 🆕 注意事项 / 备注说明 ===== -->
        <!-- ========================================================== -->
        <div class="notice-section">
          <div class="notice-header">
            <span class="notice-title">{{ $t("depositPage.noticeTitle") }}</span>
          </div>

          <div class="notice-grid">
            <div class="notice-item" v-for="item in notices" :key="item.id">
              <span class="notice-icon">{{ item.icon }}</span>
              <div class="notice-content">
                <h4>{{ item.title }}</h4>
                <p>{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DepositPage",
  data() {
    return {
      wallet: {},
      depositMethod: "crypto",
      selectedCoin: null,
      selectedProtocol: null,
      depositAmount: "",
      copied: false,

      // 币种列表（从接口获取）
      coins: [],

      onlineMethods: [
        {
          icon: "💳",
          name: this.$t("depositPage.onlineCardName1"),
          desc: this.$t("depositPage.onlineCardDesc1"),
          btn: this.$t("depositPage.onlineCardBtn1"),
        },
        {
          icon: "🏦",
          name: this.$t("depositPage.onlineCardName2"),
          desc: this.$t("depositPage.onlineCardDesc2"),
          btn: this.$t("depositPage.onlineCardBtn2"),
        },
        {
          icon: "🪙",
          name: this.$t("depositPage.onlineCardName3"),
          desc: this.$t("depositPage.onlineCardDesc3"),
          btn: this.$t("depositPage.onlineCardBtn3"),
        },
      ],

      // ===== 🆕 注意事项数据 =====
      notices: [
        {
          id: 1,
          icon: "⏱️",
          title: this.$t("depositPage.notice1Title"),
          desc: this.$t("depositPage.notice1Desc"),
        },
        {
          id: 2,
          icon: "💰",
          title: this.$t("depositPage.notice2Title"),
          desc: this.$t("depositPage.notice2Desc"),
        },
        {
          id: 3,
          icon: "🔗",
          title: this.$t("depositPage.notice3Title"),
          desc: this.$t("depositPage.notice3Desc"),
        },
        {
          id: 4,
          icon: "⚠️",
          title: this.$t("depositPage.notice4Title"),
          desc: this.$t("depositPage.notice4Desc"),
        },
      ],

    };
  },
  created() {
    this.getCurrencyList();
    this.getWallet();
  },
  computed: {
    filteredProtocols() {
      const coin = this.coins.find((c) => c.value === this.selectedCoin);
      return coin ? coin.protocol || [] : [];
    },
    selectedProtocolObj() {
      return this.filteredProtocols.find((p) => p.id === this.selectedProtocol);
    },
    selectedCoinObj() {
      return this.coins.find((c) => c.value === this.selectedCoin);
    },
    selectedProtocolLabel() {
      return this.selectedProtocolObj ? this.selectedProtocolObj.network : "";
    },
    selectedCoinLabel() {
      return this.selectedCoinObj ? this.selectedCoinObj.text : "";
    },
    currentAddress() {
      return this.selectedProtocolObj ? this.selectedProtocolObj.address : "";
    },
    currentQrCode() {
      return this.selectedProtocolObj ? this.selectedProtocolObj.qr_code : "";
    },
    transferFee() {
      const p = this.selectedProtocolObj;
      if (!p) return "";
      return `${p.transfer_fee_min} ~ ${p.transfer_fee_max}`;
    },
  },
  watch: {
    selectedCoin() {
      const protocols = this.filteredProtocols;
      this.selectedProtocol = protocols.length ? protocols[0].id : null;
    },
  },
  methods: {
    getWallet() {
      this.$api.userWallet.getWallet().then((res) => {
        this.wallet = res.data || {};
      });
    },
    getCurrencyList() {
      this.$api.chain.getCurrencyList().then((res) => {
        if (res.code === 0) {
          this.coins = res.data || [];
          if (this.coins.length) {
            this.selectedCoin = this.coins[0].value;
          }
        }
      });
    },
    getCoinIcon(text) {
      if (!text) return require("@/assets/coins/usdt.png");
      const map = {
        BTC: require("@/assets/coins/btc.png"),
        ETH: require("@/assets/coins/eth.png"),
        TRX: require("@/assets/coins/trx.png"),
        USDT: require("@/assets/coins/usdt.png"),
        USDC: require("@/assets/coins/usdc.png"),
      };
      return map[text.toUpperCase()] || require("@/assets/coins/usdt.png");
    },
    copyAddress() {
      if (this.currentAddress) {
        navigator.clipboard.writeText(this.currentAddress);
        this.copied = true;
        setTimeout(() => (this.copied = false), 3000);
      }
    },
    handleDeposit() {
      console.log("充值:", {
        coin: this.selectedCoinLabel,
        protocol: this.selectedProtocolLabel,
        amount: this.depositAmount,
      });
    },
  },
};
</script>

<style scoped>
/* ============================================================
   充值页面 - 优化版
   ============================================================ */
.deposit-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;
  background: #0a0e1a;
  color: #fff;
  min-height: 100vh;
  padding: 24px 20px;
}

/* ===== 顶部 ===== */
.deposit-header {
  text-align: center;
  padding: 16px 0 20px;
}

.deposit-title {
  font-size: 30px;
  font-weight: 800;
  margin: 0;
}

.deposit-title .highlight {
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.deposit-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.3);
  margin: 4px 0 0;
}

/* ===== 容器 ===== */
.deposit-container {
  max-width: 900px;
  margin: 0 auto;
}

/* ===== 余额 ===== */
.balance-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: rgba(0, 180, 255, 0.04);
  border: 1px solid rgba(0, 180, 255, 0.06);
  border-radius: 12px;
  margin-bottom: 18px;
}

.balance-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.3);
  display: block;
}

.balance-amount {
  font-size: 26px;
  font-weight: 700;
}

.balance-sub {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.25);
}

/* ===== Tabs ===== */
.method-tabs {
  display: flex;
  gap: 0;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 18px;
}

.method-tab {
  flex: 1;
  padding: 11px 16px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.3);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.method-tab:hover {
  color: rgba(255, 255, 255, 0.6);
}

.method-tab.active {
  color: #fff;
  background: rgba(0, 180, 255, 0.06);
  box-shadow: inset 0 -2px 0 #00b4ff;
}

/* ===== 表单 ===== */
.form-group {
  margin-bottom: 14px;
}

.form-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 8px;
}

/* ===== 币种 ===== */
.coin-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.coin-option {
  padding: 12px 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
  border: 2px solid rgba(255, 255, 255, 0.04);
  text-align: center;
  cursor: pointer;
  transition: all 0.25s ease;
}

.coin-option:hover {
  border-color: rgba(255, 255, 255, 0.08);
}

.coin-option.active {
  border-color: #00b4ff;
  background: rgba(0, 180, 255, 0.06);
}

.coin-icon {
  display: block;
  font-size: 22px;
}

.coin-img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: inline-block;
  vertical-align: middle;
}

.coin-name {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.coin-option.active .coin-name {
  color: #fff;
}

/* ===== 协议 ===== */
.protocol-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.protocol-option {
  padding: 10px 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
  border: 2px solid rgba(255, 255, 255, 0.04);
  text-align: center;
  cursor: pointer;
  transition: all 0.25s ease;
}

.protocol-option:hover {
  border-color: rgba(255, 255, 255, 0.08);
}

.protocol-option.active {
  border-color: #7c3aed;
  background: rgba(124, 58, 237, 0.06);
}

.protocol-name {
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
}

.protocol-option.active .protocol-name {
  color: #fff;
}

.protocol-sub {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.2);
}

/* ===== 支付信息 ===== */
.payment-info {
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  margin-top: 6px;
}

.qr-row {
  display: flex;
  gap: 20px;
  align-items: center;
}

.qr-wrapper {
  flex-shrink: 0;
  padding: 0px;
  background: #fff;
  border-radius: 14px;
}

.qr-img {
  width: 230px;
  height: 230px;
  display: block;
  border-radius: 8px;
}

.qr-placeholder {
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 13px;
}

.address-area {
  flex: 1;
  min-width: 0;
}

.address-box {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 8px;
}

.address-text {
  flex: 1;
  font-size: 14px;
  font-family: "SF Mono", monospace;
  color: rgba(255, 255, 255, 0.75);
  word-break: break-all;
  line-height: 1.6;
}

.btn-copy {
  padding: 5px 14px;
  border-radius: 6px;
  background: rgba(0, 180, 255, 0.08);
  border: none;
  color: #00b4ff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  font-family: inherit;
  white-space: nowrap;
}

.btn-copy:hover {
  background: rgba(0, 180, 255, 0.15);
}

.address-warning {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.3);
  margin-top: 8px;
}

.address-warning strong {
  color: #ffd866;
}

.fee-info {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 6px;
}

/* ===== 操作行 ===== */
.action-row {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.amount-input {
  flex: 1;
  padding: 11px 16px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.04);
  color: #fff;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.25s ease;
}

.amount-input:focus {
  border-color: #00b4ff;
}

.amount-input::placeholder {
  color: rgba(255, 255, 255, 0.15);
}

.btn-deposit {
  padding: 11px 32px;
  border-radius: 10px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.25s ease;
  font-family: inherit;
  white-space: nowrap;
}

.btn-deposit:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(0, 100, 255, 0.25);
}

/* ===== 空状态 ===== */
.empty-state {
  text-align: center;
  padding: 32px 16px;
  color: rgba(255, 255, 255, 0.2);
  font-size: 14px;
}

/* ===== 线上充值 ===== */
.online-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.online-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 16px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  transition: all 0.25s ease;
}

.online-card:hover {
  border-color: rgba(0, 180, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.online-icon {
  font-size: 32px;
}

.online-card h4 {
  font-size: 14px;
  font-weight: 600;
  margin: 8px 0 2px;
  color: #fff;
}

.online-card p {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.25);
  margin: 0 0 12px;
}

.btn-online {
  padding: 7px 22px;
  border-radius: 8px;
  background: rgba(0, 180, 255, 0.06);
  border: 1px solid rgba(0, 180, 255, 0.06);
  color: #00b4ff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  font-family: inherit;
}

.btn-online:hover {
  background: rgba(0, 180, 255, 0.12);
}

/* ============================================================
   🆕 注意事项 / 备注说明
   ============================================================ */
.notice-section {
  margin-top: 24px;
  padding: 18px 22px 22px;
  background: rgba(255, 215, 0, 0.02);
  border: 1px solid rgba(255, 215, 0, 0.06);
  border-radius: 12px;
}

.notice-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
}

.notice-title {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
}

.notice-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
}

.notice-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.01);
  border-radius: 8px;
  transition: background 0.2s;
}

.notice-item:hover {
  background: rgba(255, 255, 255, 0.02);
}

.notice-icon {
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}

.notice-content h4 {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 2px 0;
}

.notice-content p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.25);
  margin: 0;
  line-height: 1.5;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 768px) {
  .deposit-page {
    padding: 16px 12px;
  }

  .deposit-title {
    font-size: 24px;
  }

  .balance-amount {
    font-size: 22px;
  }

  .coin-grid,
  .protocol-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .online-grid {
    grid-template-columns: 1fr;
  }

  .qr-row {
    flex-direction: column;
    align-items: center;
  }

  .qr-img,
  .qr-placeholder {
    width: 140px;
    height: 140px;
  }

  .address-box {
    flex-wrap: wrap;
  }

  .address-text {
    font-size: 12px;
  }

  .action-row {
    flex-direction: column;
  }

  .btn-deposit {
    text-align: center;
  }

  .method-tab {
    font-size: 13px;
    padding: 9px 12px;
  }

  .payment-info {
    padding: 16px;
  }

  /* 注意事项响应式 */
  .notice-grid {
    grid-template-columns: 1fr;
    gap: 6px;
  }

  .notice-section {
    padding: 14px 16px 18px;
  }

  .notice-item {
    padding: 8px 10px;
  }
}

@media (max-width: 400px) {
  .balance-card {
    flex-direction: column;
    text-align: center;
    gap: 4px;
  }

  .coin-grid,
  .protocol-grid {
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }

  .payment-info {
    padding: 12px;
  }

  .qr-img,
  .qr-placeholder {
    width: 120px;
    height: 120px;
  }

  .notice-section {
    padding: 12px;
  }

  .notice-content p {
    font-size: 12px;
  }
}
</style>
